import React from 'react';
import PropTypes from 'prop-types';

export default function ItsYou({ name }) {
  return (
    <span>
      It's
      {' '}
      <span dangerouslySetInnerHTML={{ __html: name }} />
      !
    </span>
  );
}

ItsYou.propTypes = {
  name: PropTypes.string.isRequired,
};